import { __assign, __rest } from "tslib";
import React from 'react';
import EditPcpLink from './EditPcpLink';
import FreeDownloadLink from './FreeDownloadLink';
import PcpDownloadLink from './PcpDownloadLink';
import PcpButtonWithPopover from './PcpButtonWithPopover';
import DownloadButtonWithPopover from './DownloadButtonWithPopover';
import { useDeviationAttributes } from '../../_partials/hooks/useDeviationAttributes';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
var FreeAndPcpDownloadButton = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation.extended, _c = _b === void 0 ? {} : _b, pcp = _c.pcp, download = _c.download, buttonProps = __rest(_a, ["deviation", "deviation"]);
    var _d = useSubscriptionTier(deviation), tier = _d.tier, isOwner = _d.isOwner, isUserSubscribed = _d.isUserSubscribed, isSubscribedButBlocked = _d.isSubscribedButBlocked;
    var _e = useDeviationAttributes(deviation, isOwner), isDownloadable = _e.isDownloadable, isPurchasable = _e.isPurchasable, isExtendedLoaded = _e.isExtendedLoaded;
    var hasNeitherDownload = !isPurchasable && !isDownloadable;
    var hasCorruptedData = (isPurchasable && !pcp) || (isDownloadable && !download);
    // we may have had some deviations with isPurchasable: true but no pcp (corrupted data)
    // this may have caused icon flashing and/or the user ending up at PcpPopover
    // without any pcp
    if (!isExtendedLoaded || hasNeitherDownload || hasCorruptedData) {
        return null;
    }
    var hasBoth = isPurchasable && isDownloadable;
    var hasPcpOnly = isPurchasable && !isDownloadable;
    var hasFreeOnly = !isPurchasable && isDownloadable;
    if (isOwner && isPurchasable) {
        return React.createElement(EditPcpLink, { deviation: deviation });
    }
    if (hasFreeOnly) {
        return React.createElement(FreeDownloadLink, __assign({ deviation: deviation }, buttonProps));
    }
    // if tierAccess is locked-subscribed, you can't access the free download
    // but can still purchase the premium
    var hasBothButFreeIsBlocked = hasBoth && isSubscribedButBlocked;
    if (hasPcpOnly || hasBothButFreeIsBlocked) {
        var isSubscribedToTierIfAny = !!tier && isUserSubscribed && !isSubscribedButBlocked;
        // you get the pcp for free if you're subscribed to the tier
        var alreadyPurchasedPcp = (pcp === null || pcp === void 0 ? void 0 : pcp.hasUserPurchased) || isSubscribedToTierIfAny;
        return alreadyPurchasedPcp ? (React.createElement(PcpDownloadLink, __assign({ deviation: deviation }, buttonProps))) : (React.createElement(PcpButtonWithPopover, __assign({ deviation: deviation }, buttonProps)));
    }
    return React.createElement(DownloadButtonWithPopover, __assign({ deviation: deviation }, buttonProps));
};
FreeAndPcpDownloadButton.displayName = 'FreeAndPcpDownloadButton';
export default FreeAndPcpDownloadButton;
//# sourceMappingURL=FreeAndPcpDownloadButton.js.map